module.exports = __webpack_public_path__ + "img/DE04001.5de2076f.png";